export default {
  text: "Resize the widget with the arrow in the right bottom corner. Remove the widget by clicking the delete icon."
}
